import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useScrollPosition } from "../../Hooks/useScrollPosition";
const Header = () => {
  const scrollPos = useScrollPosition();
  return (
    <header
      className={`navbar h-16  sticky top-0 z-50 transition-shadow  ${
        scrollPos > 0
          ? "shadow bg-opacity-50 backdrop-blur-lg backdrop-filter rounded-lg"
          : "shadow-none"
      }`}
    >
      <nav className="flex justify-between items-center p-5 w-full">
        <div>
          <h2 className="text-white">WELCOME</h2>
        </div>

        <a
          href="https://wa.me/8801765888392"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Message me on WhatsApp"
          className="group flex items-center gap-2 rounded-full border border-white/15 bg-[#25D366] px-2.5 py-1.5 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md hover:shadow-[#25D366]/30"
        >
          <FaWhatsapp className="text-lg transition-transform duration-200 group-hover:scale-110" />
          <span>Let&apos;s talk</span>
        </a>
      </nav>
    </header>
  );
};

export default Header;
